import { render, staticRenderFns } from "./ProblemPriority.vue?vue&type=template&id=cbf5dc84&"
import script from "./ProblemPriority.vue?vue&type=script&lang=js&"
export * from "./ProblemPriority.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports